import React, { useCallback } from "react";
import { DocumentFragment } from '../../graphql/generated/definitions';
import useTranslations from "../../hooks/useTranslations";
import { AttachmentIcon, DotsVerticalIcon } from "../icons";
import { Menu, MenuItem, MenuList, MenuButton } from "../wombat-ui";

type DocumentPlateProps = {
  onDelete: (document: DocumentFragment) => void;
  allowDelete: boolean;
  document: DocumentFragment;
};

export const DocumentPlate: React.FC<DocumentPlateProps> = ({
  document,
  onDelete,
  allowDelete = true,
}) => {
  const t = useTranslations();

  const handleDelete = useCallback(() => {
    if (onDelete) {
      onDelete(document);
    }
  }, [onDelete, document])

  return (
    <li
      className="flex items-center justify-between py-3 text-sm"
    >
      <div className="flex items-center flex-1 w-0">
        <AttachmentIcon className="flex-shrink-0 w-5 h-5 text-gray-400" />
        <span className="flex-1 w-0 ml-2 truncate">{document.filename}</span>
      </div>
      <div className="flex items-center flex-shrink-0 ml-4">
        <a
          target={"_blank"}
          href={document.url}
          id={`downloadDocumentLink-${document.id}`}
          className="mr-3 font-medium text-primary-500 hover:text-primary-400"
        >
          {t("reviews.downloadDocument")}
        </a>
        <Menu key="remove_document">
          <MenuButton
            id={`documentMenu-${document.id}`}
            icon={DotsVerticalIcon}
            scale="inline"
            variant="ghost"
          />
          <MenuList>
            <MenuItem
              disabled={!allowDelete}
              onSelect={handleDelete}
              data-test-id={`deleteDocumentButton-${document.id}`}
            >
              {t("forms.actions.delete")}
            </MenuItem>
          </MenuList>
        </Menu>  
      </div>
    </li>
  );
};
